import './edit-package-transport.scss';

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormPackageTransport from "../form-package-transport/form-package-transport";
import { useEditPackageTransport } from "./edit-package-transport.hook";

export function EditPackageTransport() {
  const {
    packageTransportData,
    isLoading,
    packageTransportError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditPackageTransport();

  const title =
    <h1>Edit Package Transport</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormPackageTransport />
      </section>
    </div>
  );

  return (
    <div id="EditPackageTransport" className="package-transport">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { packageTransportError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditPackageTransport;